import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import AuthService from 'services/auth'
import BusinessNavbar from 'components/Navbars/BusinessNavbar'
import ItemTabs from 'components/ItemTabs'
import EditBusinessData from './BusinessData'
import EditAgenda from './Agenda'
import EditServices from './Services'
import EditBundles from './Bundles'
import EditLoyaltyCards from './LoyaltyCards'
import EditProducts from './Products'
import ConfigProfessionals from './Professionals'
import ConfigBankAccounts from './BankAccounts'
import ConfigCardMachines from './CardMachines'
import EditSecurity from './Security'
import ChangePassword from './Security/ChangePassword'
import { Container, TabStickyContainer, Title } from './styles'

export default function Config (props) {
  const location = useLocation ()
  const configOption = location.state?.configOption ?? null
  const isTutorial = location.state?.isTutorial ?? false
  const isBusiness = AuthService.isBusiness ()
  
  const TAB_LIST = [
    {label: 'Meus dados', value: 'personal_data', component: <EditBusinessData/>},
    {label: 'Agenda', value: 'agenda', component: <EditAgenda location={location} {...props}/>},
    {label: 'Serviços', value: 'services', component: <EditServices {...props}/>},
    {label: 'Pacotes', value: 'bundles', component: <EditBundles {...props}/>},
    {label: 'Fidelidade', value: 'loyalty_cards', component: <EditLoyaltyCards {...props}/>},
    {label: 'Produtos', value: 'products', component: <EditProducts {...props}/>},
    {label: 'Profissionais', value: 'professionals', component: <ConfigProfessionals/>},
    {label: 'Contas bancárias', value: 'bank_accounts', component: <ConfigBankAccounts/>},
    {label: 'Maquininhas', value: 'card_machines', component: <ConfigCardMachines/>},
  ].filter (tab => AuthService.hasPermission (`business_config.${tab.value}`))
    .concat (...isBusiness ? [
      {label: 'Segurança', value: 'security', component: <EditSecurity/>}
    ] : [
      {label: 'Alterar senha', value: 'change_password', component: <ChangePassword/>}
    ]).filter (tab => !isTutorial || tab.value === configOption)

  const [selectedTab, setSelectedTab] = useState (
    configOption ?? localStorage.getItem ('config_tab') ?? TAB_LIST[0].value
  )
  
  return (
    <Container style={{paddingLeft: 50}}>
      <BusinessNavbar/>
      <Title>Configurações</Title>
      <TabStickyContainer>
        <ItemTabs
          tabs={TAB_LIST}
          selectedTab={selectedTab}
          tabWidth={140}
          onTabChange={(value) => {
            setSelectedTab (value)
            localStorage.setItem ('config_tab', value)
          }}
        />
      </TabStickyContainer>
      {TAB_LIST.find (tab => tab.value === selectedTab)?.component}
    </Container>
  )
}
